import React from 'react'
import {InputNumber, Checkbox} from 'antd'

const Product = ({product, reducer, getProductValue}) => {
  const classNames = ['row', 'product']
  if (getProductValue('cancelled')) classNames.push('cancel')
  if (product.state === 'cancelled') classNames.push('cancelled')

  return (
    <div className={classNames.join(' ')}>
      <span className="name">{product.name}</span>
      {product.state === 'booked' && (
        <>
          {'quantity' in product && (
            <span className="quantity">
              <InputNumber
                min={product.quantity}
                value={getProductValue('quantity')}
                onChange={quantity => reducer({type: 'SET_QUANTITY', product, quantity})}
              />
            </span>
          )}
          <span className="actions">
            <Checkbox
              checked={getProductValue('cancelled')}
              onChange={e => reducer({type: 'TOGGLE_CANCELLED', product, cancelled: e.target.checked})}
            />
          </span>
        </>
      )}
    </div>
  )
}

export default Product
